import createRoute        from '@widesk-ui/tools/createRoute';
import EventWorkflowModel from '@models/website/EventWorkflowModel';

const route = createRoute.splitView(
	'/configuration/:eventWorkflowTypeReference/event_workflows',
	'website',
	'EventWorkflowSplitView',
	EventWorkflowModel.localize('plural'),
);

export default route;
